import { FC } from 'react';

export enum ExitSlipTab {
  TODAY_AND_UPCOMING = 0,
  PAST = 1,
}

interface Props {
  activeTab: ExitSlipTab;
  upcomingCount: number;
  pastCount: number;
  onChange: (tab: ExitSlipTab) => void;
}

const TABS: { tab: ExitSlipTab; label: string }[] = [
  { tab: ExitSlipTab.TODAY_AND_UPCOMING, label: 'Today & upcoming' },
  { tab: ExitSlipTab.PAST, label: 'Past' },
];

const tabClass =
  'tw-flex tw-h-9 tw-items-center tw-justify-center tw-gap-1 tw-rounded-xl tw-border-none tw-px-4 tw-py-2 tw-font-atkinson tw-text-base tw-font-bold tw-leading-5';

//one transition per element: a second tw-transition-* utility would clobber this one
const press = 'tw-transition-[color,background-color,transform] tw-duration-200 tw-ease-out';
const fade = 'tw-transition-colors tw-duration-300 tw-ease-out';

const ExitSlipModalTabBar: FC<Props> = ({ activeTab, upcomingCount, pastCount, onChange }) => {
  return (
    <div role="tablist" className="tw-inline-flex tw-w-fit tw-items-center tw-rounded-xl tw-bg-neutral-50">
      {TABS.map(({ tab, label }) => {
        const active = tab === activeTab;
        const count = tab === ExitSlipTab.PAST ? pastCount : upcomingCount;
        const empty = count === 0;

        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={empty && !active}
            onClick={() => onChange(tab)}
            className={`${tabClass} ${press} ${
              active ? 'tw-bg-neutral-950 tw-text-white' : 'tw-bg-transparent tw-text-neutral-950'
            } ${
              empty && !active
                ? 'tw-cursor-default tw-opacity-50'
                : 'tw-cursor-pointer active:tw-scale-[0.97] motion-reduce:active:tw-scale-100'
            } motion-reduce:tw-transition-none`}
          >
            <span>{label}</span>
            <span
              className={`tw-flex tw-size-5 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-text-xs tw-font-bold tw-leading-4 ${fade} ${
                active ? 'tw-bg-neutral-800 tw-text-white' : 'tw-bg-neutral-100 tw-text-neutral-950'
              }`}
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default ExitSlipModalTabBar;
